export const se = {
  translation: {
    "Belimo Energy Valve": "Belimo Energy Valve",
    Yes: "Ja",
    No: "Nej",
    "You cannot go back from this position":
      "Du kan inte gå tillbaka från den här platsen",
    Chapters: "Kapitel",
    Start: "Start",
    "Connecting to the Energy Valve":
      "Att ansluta till Energy Valve",
    "Control Source": "Styrningskälla",
    "Do you know the design flow rate?":
      "Känner du till den avsedda flödeshastighet?",
    "Flow Control": "Flödesreglering",

    "Is the building running off fixed or varying flow temperatures?":
      "Har byggnaden fasta eller varierande flödestemperaturer?",

    "Varying flow temperatures (Delta T Manager Scaling)":
      "Varierande flödestemperaturer (Delta T Manager Scaling)",

    "Fixed flow temperatures (Delta T Manager)":
      "Fasta flödestemperaturer (Delta T Manager)",

    "I am not sure": "Jag vet inte säkert",
    "Delta T Manager": "Delta T-Manager",
    Scaling: "Skalering",
    "Do you know the power output?":
      "Känner du till uteffekten?",
    "Yes (Power Control)": "Ja (effektreglering)",
    "No (Position Control)": "Nej (positionsreglering)",
    "Power Control": "Effektreglering",
    "Position Control": "Positionsreglering",
    "Onboard Data Analysis": "Onboard-dataanalys",

    "Did you get a clear result from the Energy Valve?":
      "Fick du tydliga resultat från Energy Valve?",

    "How do you want to setup your Energy Valve?":
      "Hur vill du ställa in din Energy Valve?",

    "Would you like to connect to the cloud?":
      "Vill du ansluta till molnet?",

    "Cloud Connectivity": "Molnanslutning",

    "Onboard Diagnostics / Download Data":
      "Onboard-diagnos / Ladda ner data",

    "Download Data": "Ladda ner data",
    "Send optimization request":
      "Skicka optimeringsbegäran",
    End: "Slut",

    Subtitles: "Undertexter",
    Repeat: "Upprepa",
    Continue: "Fortsätt",
  },
};
